import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultOccAccessibilityText = {
    addToAppleWalletButtonAriaLabelFormat: 'Add to Apple Wallet',
    carouselNextButtonAriaLabel: 'Scroll next',
    carouselPreviousButtonAriaLabel: 'Scroll previous',
    eventGalleryImageAltTextFormat: 'Gallery image for ${eventName}',
    eventPosterAltTextFormat: 'Theatrical poster for ${eventName}',
    filmAdvertisementAltTextFormat: 'Film advertisement for ${filmTitle}',
    filmBackdropAltTextFormat: 'Film backdrop for ${filmTitle}',
    filmPosterAltTextFormat: 'Theatrical poster for ${filmTitle}',
    filmStillAltTextFormat: 'Film still for ${filmTitle}',
    filmTitleTreatmentAltTextFormat: '${filmTitle}',
    imageCropperRotateButtonAriaLabel: 'Rotate',
    imageCropperZoomOutButtonAriaLabel: 'Zoom out',
    imageCropperZoomInButtonAriaLabel: 'Zoom in',
    itemImageAltTextFormat: 'Image for ${itemName}',
    memberPhotoAltTextFormat: 'Member photo for ${memberName}',
    memberPhotoWithoutNameAltTextFormat: 'Member photo',
    memberRewardImageAltTextFormat: 'Reward image for ${rewardName}',
    modalCloseButtonAriaLabel: 'Close modal',
    passwordInputShowPasswordButtonAriaLabel: 'Show password',
    passwordInputHidePasswordButtonAriaLabel: 'Hide password',
    redirectPaymentMethodButtonAriaLabelFormat: 'Pay with ${paymentMethodName}',
    redirectPaymentMethodIconAltTextFormat: 'Image for ${paymentMethodName}',
    removeGiftCardButtonAriaLabelFormat: 'Remove gift card ${maskedCardNumber}',
    removeMemberBalancePaymentButtonAriaLabelFormat: 'Remove payment of ${units}',
    saveToGooglePayAriaLabelFormat: 'Save to Google Pay',
    notificationCloseButtonAriaLabel: 'Close notification',
    normalSeatAriaLabelFormat: 'Normal seat ${formattedSeatLabel}',
    wheelchairSeatAriaLabelFormat: 'Wheelchair space ${formattedSeatLabel}',
    companionSeatAriaLabelFormat: 'Companion seat ${formattedSeatLabel}',
    sofaLeftSeatAriaLabelFormat: 'Left sofa ${formattedSeatLabel}',
    sofaMiddleSeatAriaLabelFormat: 'Middle sofa ${formattedSeatLabel}',
    sofaRightSeatAriaLabelFormat: 'Right sofa ${formattedSeatLabel}',
    unavailableSeatAriaLabelFormat: 'Unavailable seat ${formattedSeatLabel}'
};
export const occAccessibilityTextValidator = Validator.object({
    addToAppleWalletButtonAriaLabelFormat: nonEmptyStringValidator,
    carouselNextButtonAriaLabel: nonEmptyStringValidator,
    carouselPreviousButtonAriaLabel: nonEmptyStringValidator,
    eventGalleryImageAltTextFormat: nonEmptyStringValidator,
    eventPosterAltTextFormat: nonEmptyStringValidator,
    filmAdvertisementAltTextFormat: nonEmptyStringValidator,
    filmBackdropAltTextFormat: nonEmptyStringValidator,
    filmPosterAltTextFormat: nonEmptyStringValidator,
    filmStillAltTextFormat: nonEmptyStringValidator,
    filmTitleTreatmentAltTextFormat: nonEmptyStringValidator,
    imageCropperRotateButtonAriaLabel: nonEmptyStringValidator,
    imageCropperZoomOutButtonAriaLabel: nonEmptyStringValidator,
    imageCropperZoomInButtonAriaLabel: nonEmptyStringValidator,
    itemImageAltTextFormat: nonEmptyStringValidator,
    memberPhotoAltTextFormat: nonEmptyStringValidator,
    memberPhotoWithoutNameAltTextFormat: nonEmptyStringValidator,
    memberRewardImageAltTextFormat: nonEmptyStringValidator,
    modalCloseButtonAriaLabel: nonEmptyStringValidator,
    passwordInputShowPasswordButtonAriaLabel: nonEmptyStringValidator,
    passwordInputHidePasswordButtonAriaLabel: nonEmptyStringValidator,
    redirectPaymentMethodButtonAriaLabelFormat: nonEmptyStringValidator,
    redirectPaymentMethodIconAltTextFormat: nonEmptyStringValidator,
    removeGiftCardButtonAriaLabelFormat: nonEmptyStringValidator,
    removeMemberBalancePaymentButtonAriaLabelFormat: nonEmptyStringValidator,
    saveToGooglePayAriaLabelFormat: nonEmptyStringValidator,
    notificationCloseButtonAriaLabel: nonEmptyStringValidator,
    normalSeatAriaLabelFormat: nonEmptyStringValidator,
    wheelchairSeatAriaLabelFormat: nonEmptyStringValidator,
    companionSeatAriaLabelFormat: nonEmptyStringValidator,
    sofaLeftSeatAriaLabelFormat: nonEmptyStringValidator,
    sofaMiddleSeatAriaLabelFormat: nonEmptyStringValidator,
    sofaRightSeatAriaLabelFormat: nonEmptyStringValidator,
    unavailableSeatAriaLabelFormat: nonEmptyStringValidator
});
